var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"notify-message"},[_c('Notice',{attrs:{"content":_vm.message,"theme":"normal","leftIconType":"notice"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }